<script>
import { mdiWeb } from '@mdi/js'
import { setLocale } from '@src/plugins/i18n'

// A compact language switcher for the app bar. Shows the active locale code and
// a menu of supported languages; selecting one calls setLocale (which persists
// the choice and updates <html lang>). Deliberately usable while signed out, so
// a Spanish-speaking user can switch before logging in.
export default {
  name: 'LanguageToggle',
  data() {
    return { languageIcon: mdiWeb }
  },
  computed: {
    current() {
      return this.$i18n.locale
    },
    locales() {
      return [
        { code: 'en', label: this.$t('language.english') },
        { code: 'es', label: this.$t('language.spanish') },
      ]
    },
  },
  methods: {
    choose(code) {
      setLocale(code)
    },
  },
}
</script>

<template>
  <v-menu location="bottom end">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        color="white"
        size="small"
        :title="$t('language.label')"
        :aria-label="$t('language.label')"
      >
        <v-icon :icon="languageIcon" start />
        <span class="text-uppercase">{{ current }}</span>
      </v-btn>
    </template>
    <v-list density="compact" min-width="140">
      <v-list-item
        v-for="l in locales"
        :key="l.code"
        :active="l.code === current"
        @click="choose(l.code)"
      >
        <v-list-item-title>{{ l.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
